import { render, staticRenderFns } from "./customMessage.vue?vue&type=template&id=ace1bb20&scoped=true&"
import script from "./customMessage.vue?vue&type=script&lang=js&"
export * from "./customMessage.vue?vue&type=script&lang=js&"
import style0 from "./customMessage.vue?vue&type=style&index=0&id=ace1bb20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace1bb20",
  null
  
)

export default component.exports